import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-credits-info',
  templateUrl: './credits-info.component.html',
  styleUrls: ['./credits-info.component.scss']
})
export class CreditsInfoComponent implements OnInit {

  @Input() title: string = '';
  @Input() description: string = '';
  @Input() subText: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
